import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import './CarHireProviderLogo.scss';

const mapStateToProps = state => ({
  assetRoot: state.appState.get('assetRoot'),
});

export class CarHireProviderLogo extends Component {
  static propTypes = {
    assetRoot: PropTypes.string.isRequired,
    providerCode: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
  };

  render() {
    const { assetRoot, provider, providerCode } = this.props;
    const imageStyle = {};

    if (providerCode) {
      imageStyle.backgroundImage = `url(${assetRoot}/car-hire-providers/150x64-logo-${providerCode.toLowerCase()}.png)`;
    }

    return (
      <div className="car-hire-provider-logo" style={imageStyle}>
        {provider}
      </div>
    );
  }
}

export default connect(mapStateToProps)(CarHireProviderLogo);



/** WEBPACK FOOTER **
 ** ./src/components/CarHire/CarHireProviderLogo.jsx
 **/